import Dialog from 'components/Dialog';
import 'twin.macro';
import { ArrowRightIcon as ArrowRight } from '@heroicons/react/24/outline';
import { ChevronDoubleRightIcon as ChevronDoubleRight } from '@heroicons/react/24/outline';
import React from 'react';
import Button from 'components/Buttons/Button';
import { useIsBelowBreakpoint } from 'components/ResponsiveSwitcher/useIsBelowSize';
import tw, { css } from 'twin.macro';
import { useTranslation } from 'react-i18next';

function Header({ children }: { children: any }) {
  return (
    <div tw="text-center mb-2">
      <div tw="text-xl font-bold mb-4 text-center border border-neutral-moderate text-neutral-moderate inline-block py-2 px-4 bg-brand-quiet rounded-3xl">
        {children}
      </div>
    </div>
  );
}

export function TowColumnsWithArrowInMiddle(props: {
  children: any;
  onClose: () => void;
  isMobile?: boolean;
}) {
  const { children, onClose } = props;
  const [step, setStep] = React.useState(0);
  const { t } = useTranslation(['common', 'cahierJournal']);
  const isMobile = useIsBelowBreakpoint('md');

  return (
    <>
      <Dialog.Body
        fullHeight={isMobile}
        tw="p-0! overflow-visible! max-h-screen"
      >
        <div tw="grid grid-cols-1 md:grid-cols-2 gap-x-10 relative pt-4">
          <div
            css={[
              css`
                @media screen and (max-height: 400px) {
                  ${tw`hidden!`}
                }
              `,
              tw`invisible md:visible absolute top-60 right-1/2 bg-neutral-supershy h-20 flex items-center justify-center z-10`,
            ]}
          >
            <ArrowRight tw="h-8 w-8" />
          </div>
          {(step === 0 || !isMobile) && (
            <div
              css={[
                tw`overflow-y-auto pr-4 md:pr-0 pl-4 md:border-r border-neutral-quiet `,
                css`
                  height: calc(90vh - 4rem) !important;
                `,
              ]}
            >
              <div tw="md:pr-10">
                <Header>
                  <div tw="flex items-center">
                    {t('cahierJournal:copyEventsToAnotherDayModal.source')}
                    <ChevronDoubleRight tw="ml-2 h-6 w-6" />
                  </div>
                </Header>
                {children[0]}
              </div>
            </div>
          )}
          {(step === 1 || !isMobile) && (
            <div
              css={[
                tw`overflow-y-auto pl-4 md:pl-0 pr-4`,
                css`
                  height: calc(90vh - 4rem) !important;
                `,
              ]}
            >
              <Header>
                <div tw="flex items-center">
                  <ChevronDoubleRight tw="mr-2 h-6 w-6" />
                  {t('cahierJournal:copyEventsToAnotherDayModal.target')}
                </div>
              </Header>
              {children[1]}
            </div>
          )}
        </div>
      </Dialog.Body>
      <Dialog.Footer tw="border-neutral-quiet">
        {step === 0 && (
          <div tw="flex justify-end gap-x-2.5 md:hidden text-right w-full">
            <Button
              onClick={() => {
                onClose();
              }}
              large
              minimal
            >
              {t('common:buttons.cancel')}
            </Button>
            <Button
              onClick={() => {
                setStep(step + 1);
              }}
              intent="primary"
              large
            >
              {t('common:buttons.next')}
            </Button>
          </div>
        )}
        {(step === 1 || !isMobile) && (
          <>
            <div tw="flex justify-end w-full">
              <Button
                tw="md:hidden"
                onClick={() => {
                  setStep(0);
                }}
                large
                minimal
              >
                {t('common:buttons.previous')}
              </Button>
              {children[2]}
            </div>
          </>
        )}
      </Dialog.Footer>
    </>
  );
}
